
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

const CallToAction = () => {
  return (
    <section className="py-20 px-4 bg-corporate-primary-100">
      <div className="container mx-auto text-center max-w-3xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-corporate-white mb-6">
            Ready to Start Your Trading Journey?
          </h2>
          <p className="text-xl text-corporate-neutral-25 mb-10 leading-relaxed">
            Join thousands of successful traders and start growing your portfolio today.
          </p>
          <Link to="/signup">
            <Button size="lg" className="bg-corporate-secondary-100 hover:bg-corporate-secondary-75 text-corporate-neutral-100 px-10 py-7 text-xl font-semibold rounded-lg shadow-lg transition-all duration-300 hover:-translate-y-1">
              Get Started Now
              <ArrowRight className="ml-3 w-6 h-6" strokeWidth={2} />
            </Button>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default CallToAction;
